import { cn } from '@/lib/utils'

interface ScoreBarProps {
  value: number
  label?: string
  className?: string
  testId?: string
}

function scoreColor(value: number): string {
  if (value >= 0.75) return 'var(--score-high)'
  if (value >= 0.45) return 'var(--score-mid)'
  return 'var(--score-low)'
}

export function scoreLabel(value: number): 'high' | 'mid' | 'low' {
  if (value >= 0.75) return 'high'
  if (value >= 0.45) return 'mid'
  return 'low'
}

export function ScoreBar({ value, label, className, testId }: ScoreBarProps) {
  const clamped = Math.max(0, Math.min(1, value))
  const tier = scoreLabel(clamped)

  return (
    <div className={cn('space-y-0.5', className)} data-testid={testId}>
      {label ? (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{label}</span>
          <span className="font-medium tabular-nums text-foreground">{(clamped * 100).toFixed(0)}%</span>
        </div>
      ) : null}
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
        role="progressbar"
        aria-valuenow={Math.round(clamped * 100)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ?? 'score'}
        data-tier={tier}
      >
        <div
          className="h-full rounded-full transition-[width] duration-300"
          style={{
            width: `${clamped * 100}%`,
            backgroundColor: scoreColor(clamped),
          }}
        />
      </div>
    </div>
  )
}
